module.exports = __webpack_public_path__ + "img/node.1f127753.png";